export const INITIALIZE_STORE_AVATARS = 'storeAvatars/initialize';
export const SET_SELECTED_AVATAR = 'storeAvatars/setSelectedAvatar';
